import { v4 } from "uuid";

export const setSessionUUID = () => sessionStorage.setItem("content-builder-session", `sesh${v4()}`);
export const getSessionUUID = () => sessionStorage.getItem("content-builder-session");
export const setLastSaveTimestampFor = (learningUnitId, lastSaveTimestamp = Date.now()) =>
  sessionStorage.setItem(`content-builder-timestamp-${learningUnitId}`, lastSaveTimestamp);
export const getLastSaveTimestampFor = (learningUnitId) => sessionStorage.getItem(`content-builder-timestamp-${learningUnitId}`);
